/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    operators: {
        menu: {
            index: 'اپراتورها',
            create: 'جدید',
            list: 'اپراتورها'
        },
        table_titles: {
            id: 'شناسه',
            name: 'نام',
            is_individual: 'نوع اپراتور',
            country: 'کشور',
            setting: 'ویرایش / حذف',
        },
        edit: 'ویرایش اپراتور'
    }
}

